import styled from 'styled-components';

import { LogoWcon05 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

const Content = styled.div`
  ${mixin.flex({})}
`;

const LogoLoading = styled(LogoWcon05)`
  @keyframes loadingMotion {
    0% {
      transform: translateY(20px);
    }
    50% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(20px);
    }
  }

  margin: 30px 0;
  animation-name: loadingMotion;
  animation-iteration-count: infinite;
  animation-duration: 0.4s;
  animation-fill-mode: both;
`;

const LoadingModal = () => (
  <Content>
    <LogoLoading />
  </Content>
);

export default LoadingModal;
